/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row4_ChatgptInputs */

const en_mk_cmp_row4_chatgpt = /** @type {(inputs: Mk_Cmp_Row4_ChatgptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A private session, not for teams`)
};

const id_mk_cmp_row4_chatgpt = /** @type {(inputs: Mk_Cmp_Row4_ChatgptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi pribadi, bukan untuk tim`)
};

/**
* | output |
* | --- |
* | "A private session, not for teams" |
*
* @param {Mk_Cmp_Row4_ChatgptInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row4_chatgpt = /** @type {((inputs?: Mk_Cmp_Row4_ChatgptInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row4_ChatgptInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row4_chatgpt(inputs)
	return en_mk_cmp_row4_chatgpt(inputs)
});